import moment from 'moment';
import { DASHBOARD_OVERVIEW_QUERY } from '@/constants/urlQuery';
import { parseSearchParams } from '@/utils/urlSearch';

const STATUS_FILTER_VALUES = Object.freeze(['all', 'active', 'inactive']);

const readStringParam = (params, key) => {
  if (typeof params[key] !== 'string') return null;
  const value = params[key].trim();
  return value || null;
};

export const normalizeTeamsTimelineStatus = (value) => {
  const status = (value || '').toLowerCase();
  return STATUS_FILTER_VALUES.includes(status) ? status : 'all';
};

export function getTeamsTimelineFiltersFromSearch(search) {
  const query = parseSearchParams(search);

  let start = readStringParam(query, DASHBOARD_OVERVIEW_QUERY.start);
  let end = readStringParam(query, DASHBOARD_OVERVIEW_QUERY.end);
  const tz = readStringParam(query, DASHBOARD_OVERVIEW_QUERY.tz);
  const rawStatus = readStringParam(query, DASHBOARD_OVERVIEW_QUERY.status);

  if (start && !moment(start, 'YYYY-MM-DD', true).isValid()) start = null;
  if (end && !moment(end, 'YYYY-MM-DD', true).isValid()) end = null;
  if (start && end && moment(start).isAfter(end)) {
    start = null;
    end = null;
  }

  return {
    start,
    end,
    tz,
    status: normalizeTeamsTimelineStatus(rawStatus),
  };
}

export function getInitialTeamsTimelineDateFromSearch(search = '') {
  const { start, end } = getTeamsTimelineFiltersFromSearch(search);
  const today = moment().format('YYYY-MM-DD');

  if (start && end && start === end) return start;
  if (start && !end) return start;
  if (end && !start) return end;
  return today;
}

export function buildTeamsTimelineFilterUpdates({ start, end, tz, status }) {
  return {
    [DASHBOARD_OVERVIEW_QUERY.start]: start ?? '',
    [DASHBOARD_OVERVIEW_QUERY.end]: end ?? '',
    [DASHBOARD_OVERVIEW_QUERY.tz]: tz ?? '',
    [DASHBOARD_OVERVIEW_QUERY.status]:
      normalizeTeamsTimelineStatus(status) === 'all'
        ? ''
        : normalizeTeamsTimelineStatus(status),
  };
}
